module.exports = __webpack_public_path__ + "img/Ersa-VERSAFLOW335-GLOBAL-5572-900x675.4cea54cd.png";